import ContentTypeField from '@/ecm/models/contentType/ContentTypeField';
export default class ContentType {
    constructor (dto) {
        this.id = 0;
        this.name = '';
        this.description = '';
        this.minVersion = 0;
        this.majVersion = 1;
        this.version = 'v1.0';
        this.encryptDocuments = false;
        this.keepActualVersion = false;
        this.hasDocuments = false;
        this.isLastVersion = false;
        this.autoimportEnabled = false;
        this.fields = [];

        if (dto) {
            this.id = dto.Id;
            this.name = dto.Name;
            this.description = dto.Description;
            this.minVersion = dto.MinVersion;
            this.majVersion = dto.MajVersion;
            this.version = dto.Version;
            this.encryptDocuments = dto.EncryptDocuments || false;
            this.isLastVersion = dto.IsLastVersion;
            this.hasDocuments = dto.HasDocuments;
            this.autoimportEnabled = dto.AutoimportEnabled;
            this.fields = dto.DefFields ? dto.DefFields.map(function (dto) { return new ContentTypeField(dto); }) : [];
        }
    }

    toDto () {
        var dto = {
            Id: this.id,
            Name: this.name,
            Description: this.description,
            MinVersion: this.minVersion,
            MajVersion: this.majVersion,
            EncryptDocuments: this.encryptDocuments,
            KeepActualVersion: this.keepActualVersion,
            DefFields: [],
        };

        for (let i = 0; i < this.fields.length; i++) {
            const field = this.fields[i];
            field.order = i;
            dto.DefFields.push(field.toDto());
        }

        return { ContentTypeStr: JSON.stringify(dto) };
    }
}
